import Vue from 'vue'
import Vuex from 'vuex'
import authentication from './modules/authentication'
import organizations from '@/store/modules/organizations'
import uicontrols from '@/store/modules/uicontrols'
import users from '@/store/modules/users'
import libraries from '@/store/modules/libraries'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    roles: [],
  },
  getters: {
    roles: (state) => {
      return state.roles
    },
    getJWTToken() {
      return Vue.prototype.$auth.getTokenSilently()
    },
  },

  mutations: {
    roles(state, payload) {
      state.roles = payload
    },
  },
  modules: {
    authentication,
    organizations,
    uicontrols,
    users,
    libraries
  },
})
